import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const UserPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    userId: PropTypes.string,
    employmentType: PropTypes.string,
    userType: PropTypes.string,
    designation: PropTypes.string,
    reportingManagerId: PropTypes.string,
    reportingPathFromRoot: PropTypes.string,
    password: PropTypes.string,
    personalInfo: {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        fatherFirstName: PropTypes.string,
        fatherLastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        dob: PropTypes.any,
    },
    presentAddress: {
        flatNo: PropTypes.string,
        buildingNo: PropTypes.string,
        area: PropTypes.string,
        stateId: PropTypes.string,
        cityId: PropTypes.string,
        pincode: PropTypes.string,
    },
    permanentAddress: {
        flatNo: PropTypes.string,
        buildingNo: PropTypes.string,
        area: PropTypes.string,
        stateId: PropTypes.string,
        cityId: PropTypes.string,
        pincode: PropTypes.string,
    },
    presentAddressIsPermanentAddress: PropTypes.bool,
    bankInfo: {
        pancard: PropTypes.string,
        accountNumber: PropTypes.string,
        ifisc: PropTypes.string,
        bankName: PropTypes.string,
    },
    gst: {
        applicable: PropTypes.string,
        firmName: PropTypes.string,
        firmType: PropTypes.string,
        gstin: PropTypes.string,
    },
    active: PropTypes.bool,
    department: PropTypes.string,
});

export const UserDefaultProps = {
    _id: '',
    userId: '',
    employmentType: '',
    userType: '',
    designation: '',
    reportingManagerId: '',
    reportingPathFromRoot: '',
    password: '',
    personalInfo: {
        firstName: '',
        lastName: '',
        fatherFirstName: '',
        fatherLastName: '',
        email: '',
        phone: '',
        dob: '',
    },
    presentAddress: {
        flatNo: '',
        buildingNo: '',
        area: '',
        stateId: '',
        cityId: '',
        pincode: '',
    },
    permanentAddress: {
        flatNo: '',
        buildingNo: '',
        area: '',
        stateId: '',
        cityId: '',
        pincode: '',
    },
    presentAddressIsPermanentAddress: true,
    bankInfo: {
        pancard: '',
        accountNumber: '',
        ifisc: '',
        bankName: '',
    },
    gst: {
        applicable: true,
        firmName: '',
        firmType: '',
        gstin: '',
    },
    active: true,
    department: '',
};

export const UserYupSchema = Yup.object().shape({
    userId: Yup.string().matches(/^[a-zA-Z0-9\-_]{0,40}$/, {
        message: 'Only Alpha and Numeric without space',
        excludeEmptyString: true,
    }).required('Required.'),
    userType: Yup.string().required('Required'),
    designation: Yup.string().required('Required'),
    employmentType: Yup.string().required('Required'),
    personalInfo: Yup.object().shape({
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        phone: Yup.string().required('Required'),
    }),
});

export default {
    UserDefaultProps,
    UserPropTypes,
    UserYupSchema,
};
